/**
 * Pre-compiled pt-BR messages for SearchInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { clearInput: `Limpar entrada de pesquisa` };
